import src from "IMAGE";
export default { src, width: 1517, height: 796, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAASElEQVR42oWNuRGAMBDErv96GBhjY/zwHxDRj/gK8CarUSKhMEn5wNiJPiqNGR+esd3CphdpOBHn10++X9WZ1v3sgxLijpQSN+LCc/lvBGslAAAAAElFTkSuQmCC"};
